/* eslint-disable */
import { combineReducers } from "redux";
import {
  RECEIVE_REPORTS,
  UPDATE_TAB,
  REPORT_PAGE_STATES,
  UPDATE_SPEECH_REPORT_TAB,
  UPDATE_SPEECH_REPORT_DATA,
  UPDATE_SPEECH_REPORT_FILTERS,
  UPDATE_SPEECH_REPORT_DURATION,
  UPDATE_SPEECH_REPORT_HIGHLIGHT,
} from "./ReportActions";

const reports = (
  state = { reports: [], tabClicked: undefined },
  payload = {}
) => {
  const { type, reports } = payload;
  return type === RECEIVE_REPORTS ? { reports, tabClicked: undefined } : state;
};

const tab = (
  state = { tab: "All Reports", tabClicked: false },
  payload = {}
) => {
  const { type, tab, tabClicked } = payload;
  return type === UPDATE_TAB ? { tab, tabClicked: tabClicked } : state;
};

const _nullPageState = {
  isEnterFromHome: false,
  //Default report values
  activePlatforms: {
    wordcloud: "All_platforms",
    engagement: "",
    demographics: "All_platforms",
  },
  selectedCompetitors: {},
};

const reportPageStates = (state = _nullPageState, { type, status }) => {
  switch (type) {
    case REPORT_PAGE_STATES:
      return { ...state, ...status };
    default:
      return state;
  }
};

const initialSpeechReportFilters = {
  platform: [],
  note: [],
  pov: [],
  demographic: { age_range: [], ethnicity: [], gender: [] },
  category: [],
  product: { radio: true, value: null },
  competitor_brands: { radio: true, value: null },
};

const speechReportInitialState = {
  highlight: '',
  tab: "overview",
  duration: "6m",
  data: {
    loading: true,
    loadingReport: true,
    loadingData: false,
    submitStatus: false,
    isFiltered: false,
  },
  selectedFilters: { ...initialSpeechReportFilters },
  initialSelectedFilters: { ...initialSpeechReportFilters },
};

const speechReportReducer = (
  state = { ...speechReportInitialState },
  payload = {}
) => {
  const { type, highlight, tab, data, selectedFilters, duration } = payload;
  switch (type) {
    case UPDATE_SPEECH_REPORT_HIGHLIGHT:
      return { ...state, highlight };
    case UPDATE_SPEECH_REPORT_TAB:
      return { ...state, tab };
    case UPDATE_SPEECH_REPORT_DATA:
      return { ...state, data: { ...state.data, ...data } };
    case UPDATE_SPEECH_REPORT_FILTERS:
      return { ...state, selectedFilters: { ...selectedFilters } };
    case UPDATE_SPEECH_REPORT_DURATION:
      return { ...state, duration };
    default:
      return state;
  }
};

export default combineReducers({
  reports,
  tab,
  reportPageStates,
  speechReportReducer,
});
